<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'Associate'
  }
</script>

<style scoped>

</style>